import React from 'react';
import { AuthProvider } from './AuthContext';
import { UserProvider } from './UserProvider';

interface Props {
  children: React.ReactNode;
}

export default function AppProviders(props: Props) {
  const { children } = props;
  return (
    <AuthProvider>
      <UserProvider>{children}</UserProvider>
    </AuthProvider>
  );
}
